<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const isDark = ref(document.documentElement.classList.contains('dark'))

function toggleDarkMode() {
  isDark.value = !isDark.value
  if (isDark.value) {
    document.documentElement.classList.add('dark')
  }
  else {
    document.documentElement.classList.remove('dark')
  }
}

// Theme handling via postMessage from parent window
onMounted(() => {
  window.addEventListener('message', (event) => {
    if (event.data?.type !== 'theme')
      return

    const scheme = event.data.scheme === 'dark' ? 'dark' : 'light'
    document.documentElement.style.colorScheme = scheme

    document.documentElement.classList.toggle('dark', scheme === 'dark')
    document.documentElement.classList.toggle('light', scheme !== 'dark')
    isDark.value = scheme === 'dark'

    window.parent.postMessage({ type: 'theme:ack' }, event.origin)
  })

  if (!document.documentElement.classList.contains('dark') && !document.documentElement.classList.contains('light')
    && window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
    document.documentElement.classList.add('dark')
    document.documentElement.style.colorScheme = 'dark'
    isDark.value = true
  }
})
</script>

<template>
  <div class="min-h-screen bg-n-background transition-colors duration-200">
    <button
      class="fixed top-4 right-4 z-50 p-2 rounded-lg bg-n-solid-2 hover:bg-n-alpha-2 focus-visible:bg-n-alpha-2 outline-transparent transition-colors duration-200"
      :title="isDark ? t('common.lightMode') : t('common.darkMode')"
      @click="toggleDarkMode"
    >
      <svg
        v-if="isDark"
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-n-amber-9"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
        />
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-n-slate-11"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
        />
      </svg>
    </button>

    <router-view />
  </div>
</template>
